export function isInternalUser(email?: string | null): boolean {
  if (!email) return false;
  return /@(?:azure\.)?klardaten\.com$/i.test(email);
}
